import React, { Component, Fragment } from 'react';
import ContactUs from 'components/ContactUs';
import { HeaderUnLoggedIn } from 'scenes/Header';
import Footer from 'scenes/Footer';

class Contact extends Component {
  static propTypes = {};

  render() {
    return (
      <Fragment>
        <HeaderUnLoggedIn />
        {/*<HeaderLoggedIn />*/}
        <ContactUs i18n={this.props.i18n} />
        <Footer />
      </Fragment>
    );
  }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/scenes/Contact/Contact.js